import { render, staticRenderFns } from "./AnchorPageObjectives.vue?vue&type=template&id=6bc04eb2&scoped=true"
import script from "./AnchorPageObjectives.vue?vue&type=script&lang=js"
export * from "./AnchorPageObjectives.vue?vue&type=script&lang=js"
import style0 from "./AnchorPageObjectives.vue?vue&type=style&index=0&id=6bc04eb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc04eb2",
  null
  
)

export default component.exports